import { clone } from 'ramda';


export default class tpv {
  /**
   *
   * @type {{headers: Headers, cache: string, method: string}}
   */
  queryDefaultConfig = {
    headers: new Headers({
      Accept: 'application/json',
      'Content-Type': 'application/json'
    }),
    cache: 'default',
    method: 'GET'
  };

  /**
   *
   * @param url
   * @param method
   * @param body
   * @param headers
   * @param returnRealError
   * @param toJson
   * @returns {Promise}
   */
  query = (url, method = null, body = null, headers = null, returnRealError = false, toJson = true) => {

    const currentConfig = clone(this.queryDefaultConfig);
    if (method) {
      currentConfig.method = method;
    }
    if (body) {
      currentConfig.body = JSON.stringify(body);
    }

    headers &&
      headers.length > 0 &&
      headers.forEach(header => {
        const key = Object.keys(header)[0];
        currentConfig.headers.set(key, header[key]);
      });

    return new Promise((resolve, reject) => {
      fetch(url, currentConfig)
        .then(response => {
          if (response.ok) {
            resolve(toJson ? response.json() : true);
          } else {
            resolve({ success: response.ok, code: response.code });
          }
        })
        .catch(err => {
          console.error(err);
          reject(returnRealError ? Error(err) : { success: false, code: err });
        });
    });
  };
}
